import React from "react";
import { Link } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { categories } from "../ProductPage/products";

const categoryName = Object.fromEntries(categories.map((c) => [c.id, c.name]));

function ProductCard({ product }) {
  return (
    <Link to={product.path} className="dm-product-card">
      <div className="dm-product-card-img">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          decoding="async"
          width="240"
          height="180"
        />
      </div>
      <div className="dm-product-card-body">
        <span className="dm-product-card-cat">{categoryName[product.category]}</span>
        <span className="dm-product-card-name">{product.name}</span>
        <span className="dm-product-card-link">
          View details <ArrowForwardIcon />
        </span>
      </div>
    </Link>
  );
}

export default ProductCard;
